module.exports = __webpack_public_path__ + "img/sello-safe-travels.eadaf457.png";